import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, timeAgo, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

import Socials from '../components/socials/socials';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

//import './css/index.css';
//import './css/header.css';

class PortalAdminAccounts extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			accounts: [],
			levels: [],
			sort: ['su.id_level', 'DESC'],
		};
		this.getAccounts = this.getAccounts.bind(this);
		this.changeLevel = this.changeLevel.bind(this);
		this.setStreamStatus = this.setStreamStatus.bind(this);
		this.sort = this.sort.bind(this);
  };


  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		await value.setWorker( this.props.service );
		EventEmitter.emit('/client', {data: 'no value'});
		this.getAccounts();
	}


	componentWillUnmount() {
	}


	async getAccounts() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('sort0', this.state.sort[0]);
		params.append('sort1', this.state.sort[1]);
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/accounts`, params);
		
		consoleLog(x.data);
		this.setState({accounts: []},()=>{
			this.setState({accounts: x.data.accounts, levels: x.data.levels});
		});

		if( this.state.service.status === false ) {
			let service = this.state.service;
			service.status = true;
			service.name = x.data.servicename;
			//x.data.overview.shorttitle = x.data.description.title;
			this.setState({service, overview: x.data.overview});
			setTitle('DJ Accounts', x.data.servicename);
		};
	}
	
	

	async changeLevel(uid, level) {
		if( level === 0 ) {
			if( !window.confirm("Are you sure you wish to remove this member from the group? They will no longer be able to participate in your group or stream on your station.") ) return;
		}
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('uid', uid);
		params.append('level', level);
		const x = await putApi(`${this.context.worker[this.props.service]}/v3/admin/accounts`, params);
		consoleLog(x.status);
		this.getAccounts();
	}


	async setStreamStatus(uid, status) {
		if( status === 1 && !window.confirm("Are you sure you wish to prevent this member from streaming on your station? The disallowed DJ will remain inactive until you or another member of staff re-allow streaming.")) {
			return;
		}
		if( status === 0 && !window.confirm("Are you sure you wish to allow streaming again?")) {
			return;
		}
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('uid', uid);
		params.append('status', status);
		await putApi(`${this.context.worker[this.props.service]}/v3/admin/accounts/status`, params);
		this.getAccounts();
	}


	async sort(option) {
		let sort = this.state.sort;
		
		if( sort[0] === option ) sort[1] = sort[1] === 'ASC' ? 'DESC' : 'ASC';
		sort[0] = option;
		
		this.setState({sort}, ()=>{
			this.getAccounts();
		})
	}


	

	render() {
		const user = this.context;

		const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
			<a className="header-link dropdown-toggle" id="mainHeaderProfile" href="" ref={ref} onClick={(e)=>{e.preventDefault();onClick(e);}}>
				{children}
			</a>
		));

		const CustomMenu = React.forwardRef(({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
			const value = '';
			return (
				<div ref={ref} style={style} className={className} aria-labelledby={labeledBy}>
					<ul className="dropdown-menu border-0 main-header-dropdown  overflow-hidden header-profile-dropdown show" aria-labelledby="mainHeaderProfile">
						{React.Children.toArray(children).filter(
							(child) => !value || child.props.children.toLowerCase().startsWith(value),
						)}
					</ul>
				</div>
			);
		});

		const accounts = this.state.accounts.map((e,i) => {
			return (
				<div className="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12" key={i}> 
					<div className="card custom-card ">
						<div className="card-body"> 
							<div className="text-center">
								<span className="avatar avatar-xxxl rounded">
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
							</div>
							<div className="d-flex  text-center justify-content-between mt-1 mb-3">
								<div className="flex-fill">
									<p className="mb-0 fw-semibold fs-16 text-truncate max-w-150 mx-auto">
										<a href={`/profile/${e.username}`}>{e.title?e.title:e.username}</a>
									</p>
									<p className="mb-0 fs-12 text-muted text-truncate max-w-150 mx-auto">{e.fullname} - {e.level}</p>
								</div>
							</div>
							<Socials user={e} />
							
						</div>
						<div className="card-footer border-block-start-dashed text-center p-0">
							{e.banned===1 &&
								<div className="alert alert-solid-secondary alert-dismissible fade show">
									Streaming Disallowed! <Button size="sm" onClick={()=>this.setStreamStatus(e.id, 0)}>Allow</Button>
								</div>
							}
							<Row>
								<Col>
									<div className="text-center p-3">
										<p className="fw-semibold mb-0">Joined</p>
										<span className="text-muted fs-12">{moment(e.joined).format("Do MMM YYYY")}</span>
									</div>
								</Col>
								<Col>
									<div className="text-center p-3">
										<p className="fw-semibold mb-0">Position &#9660;</p>
										<span className="text-muted fs-12">
											<Dropdown>
												<Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
													{e.level}
												</Dropdown.Toggle>
												
												
												<Dropdown.Menu as={CustomMenu}>

													<Dropdown.Item eventKey={6} disabled={true}>Position:</Dropdown.Item>
													
													{(() => {
														return this.state.levels.map((f,j) => {
															return (
																<React.Fragment key={j}>
																	{e.level==='Radio Owner' ?
																		<Dropdown.Item eventKey={f.id} disabled={f.level!=='Radio Owner'?true:false}>{f.level==='Radio Owner'?<><FontAwesomeIcon icon="check" className="text-success" /> </>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}{f.level}</Dropdown.Item>
																	:
																		<Dropdown.Item eventKey={f.id} disabled={f.level==='Radio Owner'?true:false} onClick={()=>this.changeLevel(e.id, f.id)}>{e.level===f.level?<><FontAwesomeIcon icon="check" className="text-success" /> </>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}{f.level}</Dropdown.Item>
																	}
																</React.Fragment>
															)
														});
													})()}
													<Dropdown.Divider />
													{e.banned===0 ?
														<>
															<Dropdown.Item eventKey={5} disabled={true}>Streaming Allowed:</Dropdown.Item>
															<Dropdown.Item eventKey={2} onClick={()=>this.setStreamStatus(e.id, 1)}><FontAwesomeIcon icon="xmark" className="text-danger"/> Disable Streaming</Dropdown.Item>
														</>
													:
														<>
															<Dropdown.Item eventKey={5} disabled={true}>Streaming Disllowed:</Dropdown.Item>
															<Dropdown.Item eventKey={2} onClick={()=>this.setStreamStatus(e.id, 0)}><FontAwesomeIcon icon="check" className="text-success" /> Allow Streaming</Dropdown.Item>
														</>
													}
													<Dropdown.Divider />
													<Dropdown.Item eventKey={0} disabled={e.level==='Radio Owner'?true:false} onClick={()=>this.changeLevel(e.id, 0)}>Remove From Group</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
										</span>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="text-center p-3">
										<p className="fw-semibold mb-0">Previously Played</p>
										{e.lastplayed ?
											<span className="text-muted fs-12">{moment(e.lastplayed).format("Do MMM YYYY")}, {timeAgo(Math.floor((Date.now() - new Date(e.lastplayed).getTime())/1000))} ago</span>
										:
											<span className="text-muted fs-12">Not streamed yet.</span>
										}
										
									</div>
								</Col>
								
							</Row>
							{/*<div className="d-flex align-items-center justify-content-center">
								<div className="d-flex p-3 border-end">
									
								</div>
								<div className="d-flex p-3 border-end">
									
								</div>
								<div className="d-flex p-3">
									
								</div>
							</div>*/}
						</div>
					</div>
				</div>
			)
		});

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">DJ Accounts</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
								
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
								<Col xs={12}>
                  <div className="card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">{this.state.service.name} Team</span>
													<p className="fs-13 text-muted mb-0">Find and manage all your Admins and DJing team members here</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										<div className="card-footer">
											<ButtonGroup size="sm">
												<Button onClick={()=>this.sort('u.username')}>Sort by Name</Button>
												<Button onClick={()=>this.sort('su.id_level')}>Sort by Position</Button>
												<Button onClick={()=>this.sort('lastplayed')}>Sort by Last Played</Button>
												<Dropdown>
													<Dropdown.Toggle /*variant="success"*/ id="dropdown-basic">
														Not Played in ...
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Dropdown.Item onClick={()=>this.sort('1')}>1 Month</Dropdown.Item>
														<Dropdown.Item onClick={()=>this.sort('2')}>2 Months</Dropdown.Item>
														<Dropdown.Item onClick={()=>this.sort('3')}>3 Months</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
												
											</ButtonGroup>
										</div>
										
                  </div>
                </Col>
								
							</Row>


							<Row>

								{accounts}

							</Row>
						</div>
					</div>
				}
			</>
		);
	}
}

const Accounts = props => {
  const { service } = useParams();
  return <PortalAdminAccounts service={service} {...props} />
}
export default Accounts;